<div class="dialog-header">
    <h2 mat-dialog-title class="lmc-dialog-title dialog-title-icon">
        <mat-icon color="warn">warning</mat-icon>
        Application updated
    </h2>
    <button mat-icon-button mat-dialog-close type="button"
            class="close-button" aria-label="Close without reloading" matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <p *ngIf="data.lastDetailsSave">Updated by {{ data.lastDetailsSave }}.</p>
    <p>This application was updated on {{ data.modifiedTime }}, after you opened it.</p>
    <p>
        <strong>Reload</strong> to see the latest data. Any unsaved changes will be discarded.
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button type="button" mat-dialog-close>Close</button>
    <button mat-raised-button color="primary" type="button" mat-dialog-close="reload">Reload</button>
</mat-dialog-actions>
